<template>
  <a v-if="isExternal" :href="to">
    <slot></slot>
  </a>
  <router-link
    v-else-if="$useRouter"
    :to="to">
    <slot></slot>
  </router-link>
  <a
    v-else
    :href="to">
    <slot></slot>
  </a>
</template>

<script>
  export default {

    props: {
      to: {
        type: [String, Object],
        required: true
      },
    },

    computed: {
      isExternal() {
        return typeof this.to === 'string' &&
          (
            this.to.startsWith('http') ||
            this.to.startsWith('mailto:') ||
            this.to.startsWith('tel:')
          );
      },
    },

  }
</script>
